import React from 'react';
import { PropTypes } from 'prop-types';
import { Collapse, Icon } from 'antd';
import SidebarHeading from './SidebarHeading';

const { Panel } = Collapse;

class SidebarLocations extends React.Component {
  state = {
    isShow: false
  }


  handleOnCheckChange = (e, keyPath, locationKey) => {
    this.props.onCheckChange(e, locationKey, keyPath);
  }

  capitalize = (input) => {
    return input.charAt(0).toUpperCase() + input.slice(1);
  }

  toggleActiveClass = () => {
    this.setState({isShow: !this.state.isShow});
    window.scrollTo({top:0})
  }

  render() {
    const classActive = (classActiveProps) => {
      if (this.state.isShow && classActiveProps.includes('show')) {
        return 'sidebar show'
      } else {
        return 'sidebar'
      }
    }

    const mapNavigation = (location) => {
      return (
        <a href=" #"
          onClick={event => {
            event.stopPropagation();
            this.props.onNavigate(location)
          }}>
          <Icon type="compass" />
        </a>
      )
    }

    const headings = (headings, locationKey) => headings.map(heading => {
      const checkChange = (e, keyPath) => {
        this.handleOnCheckChange(e, keyPath, locationKey)
      }

      return (
        <SidebarHeading 
          key={ heading.key }
          isLoading={ this.props.isLoading }
          heading={ heading }
          locationKey={ locationKey }
          onCheckChange={ checkChange } />
      )
    });

    const locations = this.props.layers.map(location => {
      return (
        <Collapse key={location.key}>
          <Panel header={ this.capitalize(location.key) } 
            key={ location.key }
            extra={ mapNavigation(location.key) }>
              
            { headings(location.headings, location.key) }
          </Panel>
        </Collapse>
      )
    });

    return (
      <div className="sidebar-wrapper">
        <div className={ classActive(this.props.class) }>
          { locations }
        </div>
        {this.props.class.includes("show") &&
          <button 
            className="btn-toggle text-white" 
            onClick={this.toggleActiveClass}>
            <Icon type={this.state.isShow?"left":"right"} />
          </button>
        }
      </div>
    );
  }
}

SidebarLocations.propTypes = {
  class: PropTypes.string.isRequired,
  layers: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onNavigate: PropTypes.func.isRequired,
  onCheckChange: PropTypes.func.isRequired,
};

export default SidebarLocations;